module.exports = __webpack_public_path__ + "static/viajala-1f49b9719f58b1d7efaa0d25695c87fb.png";